import "./styles/base.css";
import { initApp } from "./app/app-init.ts";

const root = document.querySelector<HTMLDivElement>("#app");
if (root) initApp(root);
